import type { FormErrors } from 'redux-form';

import type { FormValues } from 'components/powerFlowShared/components/modals/filters';
import { MatchIdType } from 'components/powerFlowShared/components/modals/filters/criteriaFields';
import type { FiltersFormRule } from 'components/powerFlowShared/components/nodeTypes/filters';
import { MatchingOperator } from 'components/powerFlowShared/components/types';
import { SystemVariableId } from 'components/powerFlowShared/helpers/flowVariableHelpers';

type RuleErrorT = {
  match?: string;
  variable?: string;
  custom_attribute_id?: string;
  match_custom_attribute_id?: string;
};

export type ValidationT = {
  description?: string;
  rules?: RuleErrorT[];
};

export const validate = (values: FormValues): FormErrors => {
  const errors: ValidationT = {};

  if (!values.rules?.length) return errors;

  if (!values.description?.trim()) {
    errors.description = 'Adding a description is required';
  }

  const ruleErrors: RuleErrorT[] = [];
  values.rules.forEach(
    (
      {
        variable,
        match,
        matching_rule,
        variableType,
        custom_attribute_id,
        match_custom_attribute_id,
      }: FiltersFormRule,
      index: number,
    ) => {
      const ruleError: RuleErrorT = {};

      if (!variable?.trim()) {
        ruleError.variable = 'Please select an item for this filter';
      }

      if (
        !variable?.trim() ||
        (!match &&
          ![MatchingOperator.IS_EMPTY, MatchingOperator.IS_NOT_EMPTY].includes(
            matching_rule,
          ))
      ) {
        ruleError.match =
          'Add a second item so this filter can sort conversations';
      }

      if (variableType === MatchIdType.DateRange) {
        if (
          match &&
          (!Object.keys(match).length ||
            !!Object.entries(match).find(([, value]) => !value))
        ) {
          ruleError.match =
            'Add a date range so this filter can sort conversations';
        }
      }

      if (
        variable?.includes(SystemVariableId.ContactCustomAttributePrefix) &&
        !custom_attribute_id
      ) {
        ruleError.custom_attribute_id = 'Please select a variable name';
      }

      if (
        typeof match === 'string' &&
        match?.includes(SystemVariableId.ContactCustomAttributePrefix) &&
        !match_custom_attribute_id
      ) {
        ruleError.match_custom_attribute_id = 'Please select a variable name';
      }

      if (Object.keys(ruleError).length) {
        ruleErrors[index] = ruleError;
      }
    },
  );

  errors.rules = ruleErrors;

  return errors;
};
